import store from '@/store/store';

export default {
  path: 'profile',
  name: 'app-profile',
  component: () => import('@/views/app/profile/Profile.vue'),
  meta: {
    pageTitle: ''
  },
  beforeEnter: async (to, from, next) => {
    to.meta.pageTitle = 'profile.header_title';

    const profileResource = await store.state.router.privateRoot.$request().$get('profile');
    store.commit('router/updateRouteProp', {
      property: 'profileResource',
      value: profileResource
    });
    next();
  },
  props: () => ({
    profileResource: store.state.router.profileResource
  })
};
